import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { UserAuthData } from '../models/auth';
import {
  NotifyChildEvent,
  ApplicationEventsEnum,
  ChildRouteChanged,
} from '../models/events';
import { AuthService } from './auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { StorageKeyEnum } from '../enums/storage';

@Injectable({
  providedIn: 'root',
})
export class IframeEventsService {
  private originSiteUrl: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);

  public authDataReady: Subject<void> = new Subject<void>();

  constructor(
    public authService: AuthService,
    private router: Router,
  ) {
    window.addEventListener('message', this.bootstrapEvent.bind(this));
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const example: ChildRouteChanged = {
          type: ApplicationEventsEnum.RouteChanged,
          message: event.url,
        };
         // this.notifyParent(example, this.originSiteUrl.value ?? '');
      }
    });
  }

  // INCOMING EVENTS
  private bootstrapEvent(ev: MessageEvent<NotifyChildEvent>): void {
    switch (ev.data.type) {
      case ApplicationEventsEnum.UserAuthData: {
        const userData = ev.data.message;
        this.setUserAuthData(userData);
        localStorage.setItem(StorageKeyEnum.AuthToken, userData.AccessToken);
        this.authDataReady.next();
        return;
      }
      case ApplicationEventsEnum.OriginSiteUrl: {
        const originSiteUrl = ev.data.message;
        this.setOriginSiteUrl(originSiteUrl);
        return;
      }
      case ApplicationEventsEnum.RouteChanged: {
        // Routing from host
        /**
        * change only required if you want to direct to a specific route in this microservice
        * @const route is the route the is received from the host.
        * additional parameters in the split may be required
        * a better way to manipulate the route without hardcoding a split is needed
        */
        const route = ev.data.message.split('/dashboard/')[1];
        this.router.navigate([route]);
      }
    }
  }

  getBusinessUid(userAuthData: UserAuthData | null): string | null {
    if (!userAuthData) {
      return null;
    }
    return userAuthData.DefaultBusiness?.Uid ?? userAuthData.Businesses[0]?.Uid;
  }

  private setOriginSiteUrl(url: string): void {
    this.originSiteUrl.next(url);
  }

  private setUserAuthData(data: UserAuthData): void {
    this.authService.setUserAuthData(data);
  }

  // OUTGOING EVENTS
  /**
   * @param uri only pass in '*' if you do not know the target origin
   * @param event NotifyParentEvent is a coalesced type of events that are allowed to be passed in
   * @IfStatement is there to check that the microservice is sending to the correct parent address
   */
  // removed for now
  // notifyParent(event: NotifyParentEvent, uri?: string): void {
  //   if(!uri || environment.parentBase.url !== uri) {
  //     uri = environment.parentBase.url;
  //   }
  //   window.parent?.postMessage(
  //     {
  //       type: event.type,
  //       message: event.message,
  //     },
  //     uri,
  //   );
  // }
}
